/**
 * Render a workspace's raw id_client as its client-facing name.
 *
 * Workspaces are keyed by slug (`pepsi_us`), which must never reach the UI —
 * the workspace switcher shows `PEPSI US`. This is that transform, so a new
 * surface doesn't have to re-derive it.
 *
 * @param {string | null | undefined} idClient
 * @returns {string} the display name, or "" when there is no workspace
 */
export const workspaceDisplayName = (idClient) =>
  idClient ? idClient.toUpperCase().replace(/_/g, " ") : "";
